import { QUERY_KEYS } from 'api/query-keys';
import { flexPoolService } from 'ogp/services';
import { useMutation, useQueryClient } from 'react-query';

type AddFlexWorkersToFlexPoolData = {
  flexPoolId: string;
  flexWorkerIds: string[];
};

export const useAddFlexWorkersToFlexPool = () => {
  const queryClient = useQueryClient();
  const mutationFn = async (data: AddFlexWorkersToFlexPoolData) =>
    await flexPoolService.addFlexWorkersToFlexPool(data.flexPoolId, data.flexWorkerIds);

  return useMutation(mutationFn, {
    onSettled: async () => {
      await queryClient.invalidateQueries(QUERY_KEYS.flexPools());
      await queryClient.invalidateQueries(QUERY_KEYS.workers());
    },
  });
};
